const sameTool = (tool, approval) => tool?.kind === "tool"
  && tool.turnId === String(approval.turnId || "")
  && tool.toolId === String(approval.toolName || "")
  && JSON.stringify(tool.toolInput) === JSON.stringify(approval.toolInput);

export function deriveAgentActivity(events, approvals, toolLabel) {
  const approvalsById = new Map(approvals.map((approval) => [String(approval.id), approval]));
  let activity = null;

  for (const event of events) {
    const turnId = String(event.turnId || "");
    const approvalId = String(event.approvalId || "");
    if (event.type === "turn.started") {
      activity = { kind: "running", label: "Agent is working…", turnId };
    } else if (event.type === "tool.requested") {
      activity = {
        kind: "tool",
        label: `${toolLabel(event.toolName)}…`,
        turnId,
        toolId: String(event.toolId || event.toolName || ""),
        toolInput: event.toolInput,
        approvalId,
      };
    } else if (event.type === "approval.required" && activity?.kind === "tool" && sameTool(activity, event)) {
      activity = { ...activity, approvalId };
    } else if (event.type === "approval.resolved" && event.decision === "deny" && approvalId && activity?.approvalId === approvalId) {
      activity = { kind: "cancelled", label: "Cancelled", turnId, approvalId };
    } else if (["turn.completed", "turn.failed", "turn.error", "turn.cancelled"].includes(event.type) && activity?.turnId === turnId) {
      activity = null;
    }
  }

  if (activity?.kind === "tool" && activity.approvalId && approvalsById.get(activity.approvalId)?.status === "denied") {
    return { kind: "cancelled", label: "Cancelled", turnId: activity.turnId, approvalId: activity.approvalId };
  }
  return activity;
}
